import { useEffect } from 'react';
import { getAllAdminDatasets } from 'features/admin-campaigns/async';
import { adminDatasetsDataSelector } from 'features/admin-campaigns/selectors';
import { useAppDispatch, useAppSelector } from 'store/hooks';

export function useFetchAdminDatasetsEffect() {
  const dispatch = useAppDispatch();
  const datasets = useAppSelector(adminDatasetsDataSelector);

  useEffect(() => {
    if (datasets != null) {
      return;
    }

    dispatch(getAllAdminDatasets());
  }, [dispatch, datasets]);
}
